export default {
  title: 'Libraries'
}



// WEBPACK FOOTER //
// ./src/translations/en/libraries.js